exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#codeEditor{height:700px;box-shadow:5px 5px 10px #888;margin-bottom:15px;max-height:1400px}h1{padding-bottom:10px}.results{height:400px;overflow:scroll}.html,.results{box-shadow:0 0 20px #888}.html{height:600px}.row{margin-bottom:100px}#outputEditor{overflow:hidden}.link{padding-left:20px}.reset-button{margin-top:10px}.title-custom{font-family:Nova Flat,cursive;color:#251e60}.spacing-custom{margin-bottom:1%}.loading-custom{height:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0c82c4d1","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 49
// module chunks = 0